import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getChatRequestsApi } from "./chatRequestApi";

export const getChatRequests = createAsyncThunk(
    "chatRequest/getChatRequests",
    async ({ page, limit }, thunkAPI) => {
        try {
            const res = await getChatRequestsApi({ page, limit });

            return res.data.data;
        } catch (err) {
            return thunkAPI.rejectWithValue(
                err.response?.data?.message || "Failed to fetch chat requests"
            );
        }
    }
);

const chatRequestSlice = createSlice({
    name: "chatRequest",
    initialState: {
        chatRequests: [],
        total: 0,
        loading: false,
    },
    extraReducers: (builder) => {
        builder
            .addCase(getChatRequests.pending, (state) => {
                state.loading = true;
            })
            .addCase(getChatRequests.fulfilled, (state, action) => {
                state.loading = false;
                state.chatRequests = action.payload?.items || [];
                state.total = action.payload?.total || 0;
            })
            .addCase(getChatRequests.rejected, (state) => {
                state.loading = false;
            });
    },
});

export default chatRequestSlice.reducer;